import { StatelistComponent } from '../components/state/statelist.component';
import { Injectable, Component } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { DataAccessService } from '../../shared/services/dataaccess.service';
import { BaseClass } from '../../app.constants';

export class GridColumns {
  caption: string;
  dataField: string;
  width: number;
  dataType: string;
  cssClass: string;
  allowSorting: boolean;
  visible: boolean;
}; 

/* export class Caste  extends BaseClass {
  BasicSubCaste: [{
    SubCasteID: number;
    CasteID: number;
    SubCasteDescription:string;   
    SubCasteShortName:string;   
    SubCasteCode:string;   
    AddInfo:string;   
    DeleteFlag:string;    
    CreatedLoginID: number; 
    UpdatedLoginID: number; 
  }];
  CasteID: number;
  CasteDescription: string;
  CasteCode:string;    
  CreatedLoginID: number;
  UpdatedLoginID: number;
}; */
export class BasicCaste 
{
  CasteID: number;
  CasteDescription: string;
  CasteCode:string;    
  CreatedLoginID: number;
  UpdatedLoginID: number;
  BasicSubCasteList:BasicSubCasteList[];
}
export class BasicSubCasteList
{
  SubCasteID: number;
  CasteID: number;
  SubCasteDescription:string;   
  SubCasteShortName:string;   
  SubCasteCode:string;   
  AddInfo:string;   
}
export class BasicSubCaste
{
  SubCasteID: number;
  CasteID: number;
  SubCasteDescription:string;   
  SubCasteShortName:string;   
  SubCasteCode:string;   
  AddInfo:string;   
}
let gridColumns: GridColumns[] = [
  {
    "caption": 'Caste Description',
    "dataField": "CasteDescription",
    "width": 210,
    "dataType": "string",
    "cssClass": "",
    "allowSorting": true,
    "visible":true
  },
  {
    "caption": 'Caste Code',
    "dataField": "CasteCode",
    "width": 150,
    "dataType": "string",
    "cssClass": "",
    "allowSorting": true,
    "visible":true
  },
  {
    "caption": 'SubCaste Description',
    "dataField": "SubCasteDescription",
    "width": 200,
    "dataType": "string",
    "cssClass": "",
    "allowSorting": true,
    "visible":true
  },
  {
    "caption": 'SubCaste Short Name',
    "dataField": "SubCasteShortName",
    "width": 220,
    "dataType": "string",
    "cssClass": "",
    "allowSorting": true,
    "visible":true
  },
  {
    "caption": 'Sub Caste Code',
    "dataField": "SubCasteCode",
    "width": 220,
    "dataType": "string",
    "cssClass": "",
    "allowSorting": true,
    "visible":true
  },
  {
    "caption": 'Add Info',
    "dataField": "AddInfo",
    "width": 100,
    "dataType": "string",
    "cssClass": "",
    "allowSorting": true,
    "visible":true
  }
];
@Component({
  providers: [DataAccessService]
})
@Injectable()
export class CasteService {

  constructor(private dataService: DataAccessService)
  { 
    this.dataService.setControllerName = '/BasicCaste/';/// setting controller name for API
  }

  public  CasteData: BasicCaste;
  public errormsg;
  public successmsg;
  public getAllCaste() {
    this.dataService.setControllerName = '/BasicCaste/';
    this.dataService.setMethodName = 'GetBasicCasteList?CasteID=0'; // setting method name from API controller.
    return this.dataService.getAll<BasicCaste[]>()
  }
  public getAllSubCaste() {
    this.dataService.setControllerName = '/BasicSubCaste/';
    this.dataService.setMethodName = 'GetBasicSubCasteList?SubCasteID=0'; 
    return this.dataService.getAll<BasicSubCaste>()
  }
  public getAllCasteSubCaste() {
    this.dataService.setControllerName = '/BasicCaste/';
    this.dataService.setMethodName = 'GetBasicCasteForList?CasteID=0'; // setting method name from API controller.
    return this.dataService.getAll<BasicCaste[]>()
  }

  public getCasteByID(CasteID) {
    this.dataService.setControllerName = '/BasicCaste/';
    this.dataService.setMethodName = 'GetBasicCasteListByID?CasteID=' + CasteID + ''; 
    return this.dataService.getAll<BasicCaste>()
  }
  public getSubCasteByCasteID(CasteID) {
    this.dataService.setControllerName = '/BasicSubCaste/';
    this.dataService.setMethodName = 'GetBasicSubCasteListByCasteID?CasteID=' + CasteID + ''; 
    return this.dataService.getAll<BasicSubCasteList>()
  }
  public getCasteByeReservationCategoryID(ReservationCategoryID) {
    this.dataService.setControllerName = '/BasicCaste/';
    this.dataService.setMethodName = 'GetCasteByeReservationCategoryID?ReservationCategoryID=' + ReservationCategoryID + ''; 
    return this.dataService.getAll<BasicCaste>()
  }
  public save(data) {
    this.dataService.setControllerName = '/BasicCaste/';
    this.dataService.setMethodName = 'PostInsertBasicCaste'; // setting method name from API controller.
    return this.dataService.add<BasicCaste[]>(data) 
  }
  public update(data) {debugger
    this.dataService.setControllerName = '/BasicCaste/';
    this.dataService.setMethodName = 'PostBasicCaste'; // setting method name from API controller.
    return this.dataService.add<BasicCaste[]>(data)
  }
  public delete(data) {
    this.dataService.setControllerName = '/BasicCaste/';
    this.dataService.setMethodName = 'PostDeleteBasicCaste'; // setting method name from API controller.
    return this.dataService.delete<BasicCaste[]>(data)
  }

  getGridColumns() {
    return gridColumns;
  }
  
}
